<div class="max-w-150">
  <header class="mb-8">
    <h1 class="m-0 mb-2 text-[1.75rem] font-extrabold tracking-tight text-fg">Settings</h1>
    <p class="m-0 text-[0.9375rem] text-muted">Manage your account settings and preferences.</p>
  </header>

  <div class="overflow-hidden rounded-xl border border-border bg-card">
    <div class="flex items-center gap-3 border-b border-border bg-surface-muted px-6 py-5 text-fg-secondary">
      <ng-icon name="lucideKey" size="20" />
      <h2 class="m-0 text-base font-bold text-fg">Change Password</h2>
    </div>

    <form (ngSubmit)="onSubmit()" class="p-6">
      @if (success()) {
        <ui-alert variant="success">
          <div class="flex items-center gap-2.5">
            <ng-icon name="lucideCircleCheck" size="18" />
            <span>{{ success() }}</span>
          </div>
        </ui-alert>
      }

      @if (error()) {
        <ui-alert variant="danger">
          <div class="flex items-center gap-2.5">
            <ng-icon name="lucideCircleAlert" size="18" />
            <span>{{ error() }}</span>
          </div>
        </ui-alert>
      }

      <ui-form-field for="currentPassword" label="Current Password">
        <input
          uiInput
          type="password"
          id="currentPassword"
          [(ngModel)]="currentPassword"
          name="currentPassword"
          autocomplete="current-password"
          placeholder="Enter your current password"
        />
      </ui-form-field>

      <ui-form-field for="newPassword" label="New Password">
        <input
          uiInput
          type="password"
          id="newPassword"
          [(ngModel)]="newPassword"
          name="newPassword"
          autocomplete="new-password"
          placeholder="Enter your new password"
        />
      </ui-form-field>

      <ui-form-field for="confirmPassword" label="Confirm New Password">
        <input
          uiInput
          type="password"
          id="confirmPassword"
          [(ngModel)]="confirmPassword"
          name="confirmPassword"
          autocomplete="new-password"
          placeholder="Confirm your new password"
        />
      </ui-form-field>

      <div class="mt-2 border-t border-border pt-5">
        <button type="submit" uiButton variant="primary" [disabled]="loading()">
          {{ loading() ? 'Changing...' : 'Change Password' }}
        </button>
      </div>
    </form>
  </div>
</div>
